import { RecomendacaoModel } from 'projects/core/src/lib/core/model/RecomendacaoModel';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { DetalhesAtivoPage } from './detalhes-ativo.page';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ContratoProvider } from 'projects/core/src/lib/core/provider/ContratoProvider';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { AppSession } from 'projects/core/src/lib/core/AppSession';

export class DetalhesAtivoViewModel {
    constructor() {}

    recomendacaoModel = new RecomendacaoModel()
    contratoProvider = new ContratoProvider()
    context: DetalhesAtivoPage

    setContext(context: DetalhesAtivoPage) {
        this.context = context
    }

    getContext(): DetalhesAtivoPage {
        return this.context
    }

    async getAtivo(idAtivo: Number) {
        try {
            let retorno = await this.recomendacaoModel.getAtivoPorId(idAtivo)
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().setAtivo(retorno.data)
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {
            throw new Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

    async buscaContratos() {
        const retorno = await this.contratoProvider.listaContratosPorUsuario()
        await AppStorage.set(AppSession.CHAVE_CONTRATO_USUARIO, retorno)
        this.getContext().setListaContratos(retorno)
    }
}